import React, { useState } from "react";
import CommonBudgetTable from "./components/CommonBudgetTable";
import TransactionScreen from "./screens/TransactionScreen";
import { allHeaderTab } from "./utils/string";
import BudgetPlanning from "./screens/BudgetPlanning";
import Header from "./components/Header";
import FinancialDashboard from "./screens/AnnualView";
import DashboardView from "./screens/DashboardView";


function Main({ pageViewHandler, admin }) {
  const [selectedTab, setSelectedTab] = useState(allHeaderTab.dashboard);
  const [selectedMonthTab, setSelectedMonthTab] = useState({});
  const handleSelectedTab = (value) => {
    if (!(value === selectedTab)) {
      setSelectedMonthTab({});
      setSelectedTab(value);
    }
  };

  return (
    <div className="" style={{ marginTop: "-2%" }}>
      <Header
        pageViewHandler={pageViewHandler}
        selectedTab={selectedTab}
        setSelectedTab={handleSelectedTab}
        setSelectedMonthTab={setSelectedMonthTab}
        selectedMonthTab={selectedMonthTab}
      />
      <div
        style={{
          marginTop:
            window.innerWidth < 1220
              ? "15%"
              : window.innerWidth > 1900
                ? "7%"
                : "12%",
        }}
      >
        {selectedTab === allHeaderTab.dashboard ? (
          <DashboardView />
        ) : selectedTab === allHeaderTab.annualView ? (
          <FinancialDashboard />
        ) : selectedTab === allHeaderTab.budgetPlanning ? (
          <BudgetPlanning admin={admin}/>
        ) : (
          <TransactionScreen monthlyTab={selectedMonthTab?.monthValue ?? ""} />
        )}
      </div>
    </div>
  );
}

export default Main;
